import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-126">
      <div className="max-w-4xl mx-auto text-center" data-id="element-127">
        <div className="text-[#FFD700] text-3xl font-black tracking-widest mb-8" data-id="element-128">
          🎭 PROFEPACK®
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-129">
          El próximo domingo podés seguir buscando en internet.
        </h2>
        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-10" data-id="element-130">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Compact Cost Table */}
        <div className="bg-[#1a1400] border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-131">
          <div className="p-3 bg-[#0d0a00] border-b border-[#FFD700]/30 text-center font-bold text-white text-sm" data-id="element-132">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          {[['120 hs/año planificando desde cero', '10 min/semana. El resto es enseñar.'], ['Evaluaciones inventadas', '18 rúbricas exactas y defendibles'], ['Función anual improvisada', 'Guiones + templates = el mejor show del año'], ['Grupo difícil sin estrategia', 'Sistema 3S = control en 10 segundos']].map(([without, withPack], i) => <div key={i} className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800 last:border-b-0" data-id="element-133">
              <div className="p-3 text-gray-400 text-xs sm:text-sm" data-id="element-134">
                {without}
              </div>
              <div className="p-3 text-white font-bold text-xs sm:text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-135">
                {withPack}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-136">
          <p className="text-white font-bold mb-4" data-id="element-137">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-138" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-139">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-140">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-141">
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-142">
            <div className="text-2xl mb-2" data-id="element-143">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-144">
              MEGAPACK TEATRO LISTO
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-145">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-146">
              <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-147">
                $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48097215480064:1" className="btn-green-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-[#FFE44D] transition-colors text-sm" data-id="element-148">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#0d0a00] border-2 border-[#FFD700] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(255,215,0,0.2)] flex flex-col" data-id="element-149">
            <div className="text-2xl mb-2" data-id="element-150">🏆</div>
            <h3 className="text-[#FFD700] font-black mb-1" data-id="element-151">
              MEGAPACK + TEATRO EN ESCENA PRO ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-152">
              6 Tomos + 6 Bonos + Teatro en Escena Pro™
            </p>
            <div className="mt-auto" data-id="element-153">
              <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-154">
                $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48166240878848:1" className="btn-green-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-[#FFE44D] transition-colors text-sm" data-id="element-155">
                → QUIERO EL MEGAPACK + TEATRO EN ESCENA PRO
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-156">
          <span data-id="element-157">🔒 Pago 100% seguro</span>
          <span data-id="element-158">⚡ Acceso en 5 minutos</span>
          <span data-id="element-159">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-160">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}